import React, { useState } from "react";
// import i18n from "i18n";
import ProductAddedItemLocation from "../ProductAddedItemLocation";
import Pagination from "../../../../atoms/Pagination";
import styles from "./ProductAddedListLocation.module.scss";
import i18n from "i18n";

export const ProductAddedListLocation = ({
  products,
  total,
  handleDelete,
  changePage,
  pagination,
  title = i18n.t("requested.products"),
}) => {
  const [toggleOpen, setToggleOpen] = useState(false);
  return (
    <div className={styles["product-added-list-wrapper"]}>
      <div
        className={styles[`product-added-list-title`]}
        onClick={() => setToggleOpen(!toggleOpen)}
      >
        <div className={styles[`product-added-list-title-wrapper`]}>
          {title} ({total})
        </div>
      </div>

      {
        <div className={styles["product-added-list-products"]}>
          {products.map((product) => {
            return (
              <div key={product.id}>
                {" "}
                <ProductAddedItemLocation
                  product={product}
                  locations={product.extra}
                  handleDelete={handleDelete}
                />{" "}
              </div>
            );
          })}
          <div className={styles["product-added-list-pagination"]}>
            <Pagination
              pageQuantity={pagination.pageQuantity}
              currentPage={pagination.currentPage}
              pageChangeHandler={changePage}
            />
          </div>
        </div>
      }
    </div>
  );
};

export default ProductAddedListLocation;
